import { Box, MenuItem, TextField } from "@mui/material";
import { FieldProps } from "formik";
import { FC, useMemo, useState } from "react";

export interface DropDownItem {
  id: string;
  name: string;
  description?: string;
}

export interface StandardDropDownProps {
  id: string;
  label: string;
  width?: number;
  readonly?: boolean;
  required?: boolean;
  items?: DropDownItem[];
  onChange?: any;
}

export const StandardDropDown: FC<StandardDropDownProps & FieldProps> = ({
  field,
  form: { touched, errors },
  onChange,
  ...props
}) => {
  const [isError, setIsError] = useState<boolean>(false);
  const determineError = useMemo(() => {
    if (errors[field.name] && touched[field.name]) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [touched, errors]);

  return (
    <>
      <TextField
        select
        id={props.id}
        error={isError}
        disabled={props.readonly}
        label={props.label}
        variant="outlined"
        size="small"
        style={{ width: props.width, marginRight: 10 }}
        helperText={errors[field.name]?.toString()}
        {...field}
        onChange={onChange}
      >
        {props.items &&
          props.items.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <span className="flex flex-col gap-0">
                {option.name}
                {option.description && option.description?.length > 0 && (
                  <span style={{ fontSize: 11 }}>{option.description}</span>
                )}
              </span>
            </MenuItem>
          ))}
      </TextField>
    </>
  );
};
